var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCrossThin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.106083 11.8939C0.176785 11.9646 0.269443 12 0.362101 12C0.454758 12 0.547416 11.9646 0.618119 11.8939L6 6.51204L11.3819 11.894C11.4526 11.9646 11.5453 12 11.638 12C11.7306 12 11.8232 11.9646 11.894 11.894C12.0353 11.7526 12.0353 11.5233 11.894 11.3819L6.51204 6L11.894 0.61809C12.0353 0.476685 12.0353 0.247459 11.894 0.106054C11.7526 -0.0353513 11.5233 -0.0353513 11.3819 0.106054L6 5.48796L0.61809 0.106112C0.476685 -0.0352933 0.247459 -0.0352933 0.106054 0.106112C-0.0353513 0.247488 -0.0353513 0.476743 0.106054 0.618148L5.48796 6.00003L0.106083 11.3819C-0.0353223 11.5233 -0.0353223 11.7526 0.106083 11.8939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossThin);
export default __webpack_public_path__ + "static/media/close-cross-thin.7dd92888e2fb5001ad07e1d64c6081f6.svg";
export { ForwardRef as ReactComponent };